// error.interceptor.ts
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ErrorDialogComponent } from '../../shared/modals/error-dialog/error-dialog.component';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const dialog = inject(MatDialog);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 500 || error.status === 400) {
        dialog.open(ErrorDialogComponent, {
          width: '400px',
          data: {
            data:{
              headerMessage: error.error?.headerMessage || 'Server Error',
              errorMessages: error.error?.errorMessages || ['An unexpected error occurred'],
            },
          }
        });
      }
      return throwError(() => error);
    })
  );
};
